var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-navbar',{staticClass:"justify-content-center",attrs:{"toggleable":"lg","fixed":"bottom","variant":"transparent"}},[_c('b-nav',[_c('p',{staticClass:"text-center my-2 text-light"},[_vm._v("Smartfarm Solutions Developed By Feed Business 2021 © Copyright Reseved")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }